import { createContext, useContext } from 'react'

/**
 * The children of the line an element sits in, provided by the line block for everything it renders.
 *
 * An inline element that reads its siblings must read them from here, not from the editor at render
 * time. slate-react memoizes each element on its own identity, so an element whose siblings change
 * is not re-rendered and keeps showing what it read before: a chord that renames the one before it,
 * a chord appended after the last one (GH #2002). The line itself IS replaced when any of its
 * children changes, so it re-renders, and a context value changes with it — React delivers that
 * through the memo, to the consumers inside that one line and nowhere else.
 *
 * The value is the line's own `children` array, never a derived object rebuilt per render, so
 * consumers re-render exactly when the line changes. `undefined` outside a line.
 */
export const LineChildrenContext = createContext<readonly unknown[] | undefined>(undefined)

export const useLineChildren = () => useContext(LineChildrenContext)
